(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(() => {
  const OFFERS = [
    { key:'inner_glow', label:'INNER GLOW', code:'ANUP-IG-4K8Q2M7P', targetCents:1000, normalCents:2999, choices:[{handle:'inner-glow-90-cap-nutravixxen', label:'Inner Glow'}] },
    { key:'horse_nrg', label:'HORSEPOWER NRG', code:'ANUP-HNRG-7T3M9Q2L', targetCents:1000, normalCents:2999, choices:[{handle:'horsepower-nrg-sweet-tea', label:'Sweet Tea'},{handle:'horsepower-nrg-kiwi-strawberry', label:'Kiwi Strawberry'}] },
    { key:'slim_pill', label:'SLIM PILL', code:'ANUP-SLIM-6P2R8K4N', targetCents:1000, normalCents:2999, choices:[{handle:'slim-pill-90ct', label:'Slim Pill'}] },
    { key:'straps', label:'NUTRAMEDZ LIFTING STRAPS', code:'ANUP-STRAP-5V9M2Q7K', targetCents:500, normalCents:999, choices:[{handle:'lifting-straps-nutramedz', label:'Lifting Straps'}] },
    { key:'stim_xtl', label:'STIM XTL', code:'ANUP-STIM-8N4Q6P2R', targetCents:1000, normalCents:3999, choices:[{handle:'stim-xtl-60ct', label:'Stim XTL'}] },
    { key:'pump_xxl', label:'PUMP XXL', code:'ANUP-PUMP-3M7K9Q5V', targetCents:1000, normalCents:3999, choices:[{handle:'pump-xxl-premier-nutrition-rainbow-italian-ice', label:'Rainbow Italian Ice'},{handle:'pump-xxl-premier-nutrition-grape', label:'Grape'}] },
    { key:'horsepower', label:'HORSEPOWER', code:'ANUP-HPWR-9Q2K6M4T', targetCents:1000, normalCents:2999, choices:[{handle:'horsepower-pina-colada', label:'Pina Colada'},{handle:'horsepower-bomb-pop', label:'Bomb Pop'}] },
    { key:'shaker_3in1', label:'ADVANCED NUTRITION 3-IN-1 SHAKER', code:'ANUP-3IN1-2K8M5Q7P', targetCents:500, normalCents:1099, choices:[{handle:'shaker-3-in-1-advanced', label:'3-in-1 Shaker'}] },
    { key:'shorty_shaker', label:'MUSCLESPORT SHORTY SHAKER', code:'ANUP-SHORTY-4Q7M2K9V', targetCents:500, normalCents:1099, choices:[{handle:'musclesport-shorty-shaker', label:'Shorty Shaker'}] }
  ];
  const OFFER_BY_KEY = Object.fromEntries(OFFERS.map((offer) => [offer.key, offer]));
  const UPSELL_CODES = new Set(OFFERS.map((offer) => offer.code));
  const root = window.Shopify?.routes?.root || '/';
  const endpoint = (path) => `${root}${path}`;
  const cartRoot = document.querySelector('[data-an-cart]');
  if (!cartRoot) return;

  const dialog = cartRoot.querySelector('[data-upsell-dialog]');
  const form = cartRoot.querySelector('[data-an-cart-form]');
  const realCheckout = cartRoot.querySelector('[data-real-checkout]');
  const track = cartRoot.querySelector('[data-upsell-track]');
  const status = cartRoot.querySelector('[data-upsell-status]');
  const total = cartRoot.querySelector('[data-an-cart-total]');
  let offersLoaded = false;

  const requestJson = async (url, options = {}) => {
    const response = await fetch(url, options);
    const data = await response.json();
    if (!response.ok) throw new Error(data?.description || data?.message || 'Shopify cart request failed.');
    return data;
  };
  const getCart = () => requestJson(endpoint('cart.js'));
  const offerKeyFromItem = (item) => item?.properties?._an_upsell || '';
  const formatMoney = (cents, currency = 'USD') => new Intl.NumberFormat(undefined, {style:'currency', currency}).format(cents / 100);
  const updateTotal = (cart) => { if (total) total.textContent = formatMoney(cart.total_price, cart.currency); };

  const existingNonUpsellCodes = (cart) => {
    const codes = new Set();
    const inspect = (application) => {
      if (application?.type === 'discount_code' && application?.title && !UPSELL_CODES.has(application.title)) codes.add(application.title);
    };
    (cart.cart_level_discount_applications || []).forEach(inspect);
    (cart.items || []).forEach((item) => (item.line_level_discount_allocations || []).forEach((allocation) => inspect(allocation.discount_application)));
    return [...codes];
  };
  const activeUpsellCodes = () => []; // SMART Functions automatic discount; never apply legacy offer codes.
  const syncDiscounts = async (cart) => {
    const desired = [...new Set([...existingNonUpsellCodes(cart), ...activeUpsellCodes(cart)])];
    return requestJson(endpoint('cart/update.js'), {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({discount:desired.join(',')})});
  };
  const verifyTaggedUpsells = (cart) => (cart.items || []).filter((item) => {
    const key = offerKeyFromItem(item);
    return key && (!OFFER_BY_KEY[key] || item.selling_plan_allocation || item.quantity !== 1 || item.final_line_price !== OFFER_BY_KEY[key].targetCents || (cart.items || []).filter((line) => offerKeyFromItem(line) === key).length !== 1);
  });
  const rollbackLine = async (lineKey) => {
    const cart = await requestJson(endpoint('cart/change.js'), {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({id:lineKey, quantity:0})});
    return syncDiscounts(cart);
  };

  const stockIds = new Set(JSON.parse(document.querySelector('[data-an-upsell-stock]')?.textContent || '[]').filter(Boolean).map(String));
  const cleanOfferLines = async (cart) => {
    const invalid = verifyTaggedUpsells(cart);
    for (const item of invalid) cart = await rollbackLine(item.key);
    if (verifyTaggedUpsells(cart).length) throw new Error('Checkout add-ons could not be removed. Please retry.');
    updateTotal(cart);
    return {cart, removed:invalid.length};
  };
  const loadChoice = async (choice, expectedPrice) => {
    try {
      const product = await requestJson(endpoint(`products/${choice.handle}.js`));
      const variant = (product.variants || []).find((item) => item.available && stockIds.has(String(item.id)) && item.price === expectedPrice);
      if (!variant) return null;
      return {handle:choice.handle, label:choice.label, variantId:variant.id, price:variant.price, image:product.featured_image || product.images?.[0] || ''};
    } catch { return null; }
  };

  const createCard = (offer, choices, currency) => {
    const card = document.createElement('article');
    card.className = 'an-upsell-card';
    card.dataset.offer = offer.key;
    const image = document.createElement('div');
    image.className = 'an-upsell-image';
    const img = document.createElement('img');
    img.alt = offer.label;
    img.loading = 'lazy';
    if (choices[0].image) img.src = choices[0].image;
    else image.innerHTML = '<div class="an-upsell-placeholder">ADVANCED<br>NUTRITION</div>';
    if (choices[0].image) image.appendChild(img);
    card.appendChild(image);

    const title = document.createElement('h3');
    title.textContent = offer.label;
    card.appendChild(title);

    let select = null;
    if (choices.length > 1) {
      select = document.createElement('select');
      select.className = 'an-upsell-select';
      select.setAttribute('aria-label', `${offer.label} flavor`);
      choices.forEach((choice) => {
        const option = document.createElement('option');
        option.value = String(choice.variantId);
        option.textContent = choice.label;
        option.dataset.image = choice.image || '';
        select.appendChild(option);
      });
      select.addEventListener('change', () => {
        const selected = choices.find((choice) => String(choice.variantId) === select.value);
        if (selected?.image && image.querySelector('img')) image.querySelector('img').src = selected.image;
      });
      card.appendChild(select);
    }

    const price = document.createElement('div');
    price.className = 'an-upsell-price';
    price.innerHTML = `<s>${formatMoney(offer.normalCents, currency)}</s><strong>${formatMoney(offer.targetCents, currency)}</strong>`;
    card.appendChild(price);

    const add = document.createElement('button');
    add.className = 'an-upsell-add';
    add.type = 'button';
    add.textContent = `ADD FOR ${formatMoney(offer.targetCents, currency).replace('.00','')}`;
    add.addEventListener('click', async () => {
      const selectedId = Number(select?.value || choices[0].variantId);
      add.disabled = true;
      status.className = 'an-upsell-status';
      status.textContent = 'Adding your checkout deal...';
      try {
        await requestJson(endpoint('cart/add.js'), {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items:[{id:selectedId, quantity:1, properties:{_an_upsell:offer.key}}]})});
        const afterAdd = await getCart();
        const discounted = await syncDiscounts(afterAdd);
        const taggedLine = discounted.items.find((item) => offerKeyFromItem(item) === offer.key);
        if (!taggedLine || taggedLine.quantity !== 1 || taggedLine.final_line_price !== offer.targetCents) {
          if (taggedLine?.key) await rollbackLine(taggedLine.key);
          throw new Error('The checkout price could not be verified, so the item was not added.');
        }
        updateTotal(discounted);
        card.classList.add('is-added');
        add.textContent = 'ADDED ✓';
        status.classList.add('is-success');
        status.textContent = `${taggedLine.product_title} added at ${formatMoney(offer.targetCents, discounted.currency)}.`;
      } catch (error) {
        add.disabled = false;
        add.textContent = `ADD FOR ${formatMoney(offer.targetCents, currency).replace('.00','')}`;
        status.classList.add('is-error');
        status.textContent = error.message || 'That add-on could not be added.';
      }
    });
    card.appendChild(add);
    return card;
  };

  const loadOffers = async () => {
    if (offersLoaded) return track.children.length;
    offersLoaded = true;
    status.className = 'an-upsell-status';
    status.textContent = 'Loading checkout specials...';
    const cart = await getCart();
    const inCartOffers = new Set((cart.items || []).map(offerKeyFromItem));
    for (const offer of OFFERS) {
      if (inCartOffers.has(offer.key)) continue;
      const choices = (await Promise.all(offer.choices.map((choice) => loadChoice(choice, offer.normalCents)))).filter(Boolean);
      if (choices.length) track.appendChild(createCard(offer, choices, cart.currency));
    }
    status.textContent = '';
    return track.children.length;
  };

  const proceedToCheckout = async () => {
    if (!form || !realCheckout) return;
    const continueButton = cartRoot.querySelector('[data-upsell-continue]');
    if (continueButton) continueButton.disabled = true;
    status.className = 'an-upsell-status';
    status.textContent = 'Verifying checkout prices...';
    try {
      const cart = await getCart();
      const synced = await syncDiscounts(cart);
      if (verifyTaggedUpsells(synced).length) {
        status.classList.add('is-error');
        status.textContent = 'One of the checkout deals could not be verified. Remove it and try again.';
        if (continueButton) continueButton.disabled = false;
        return;
      }
      form.requestSubmit(realCheckout);
    } catch (error) {
      status.classList.add('is-error');
      status.textContent = error.message || 'Could not verify the checkout deals.';
      if (continueButton) continueButton.disabled = false;
    }
  };

  if (form) {
    cartRoot.querySelector('[data-open-upsell]')?.setAttribute('disabled', '');
    getCart().then(syncDiscounts).then(cleanOfferLines).then(({removed}) => {
      if (removed) window.location.reload();
      else cartRoot.querySelector('[data-open-upsell]')?.removeAttribute('disabled');
    }).catch(() => {
      if (status) status.textContent = 'Checkout add-on prices could not be verified. Reload to retry.';
    });
  }
  cartRoot.querySelectorAll('[data-upsell-remove]').forEach((button) => button.addEventListener('click', async () => {
    button.disabled = true;
    try { await rollbackLine(button.dataset.lineKey); window.location.reload(); }
    catch (error) { button.disabled = false; window.alert(error.message || 'Could not remove the checkout add-on.'); }
  }));

  cartRoot.querySelector('[data-open-upsell]')?.addEventListener('click', async () => {
    if (!dialog) return proceedToCheckout();
    dialog.showModal();
    try {
      const count = await loadOffers();
      if (!count) { dialog.close(); proceedToCheckout(); }
    } catch (error) {
      status.classList.add('is-error');
      status.textContent = error.message || 'Could not load checkout specials.';
    }
  });
  cartRoot.querySelector('[data-upsell-close]')?.addEventListener('click', () => dialog?.close());
  cartRoot.querySelector('[data-upsell-continue]')?.addEventListener('click', proceedToCheckout);
  dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  cartRoot.querySelector('[data-upsell-prev]')?.addEventListener('click', () => track?.scrollBy({left:-(track.clientWidth * .8), behavior:'smooth'}));
  cartRoot.querySelector('[data-upsell-next]')?.addEventListener('click', () => track?.scrollBy({left:track.clientWidth * .8, behavior:'smooth'}));
})();

  } catch(e) { console.error(e); }
})();
})();
